/**
 * O link do Sapron para a Wallet.
 *
 * O repasse legado (WAL-F01) manda o access token do Sapron na URL para a
 * Wallet abrir logada. Com sessao do IDP isso deixa de existir: as duas apps
 * sao clients do mesmo realm e a Wallet entra pela sessao SSO do Keycloak, sem
 * token nenhum atravessando o navegador — que e a proibicao numero um do
 * contrato do IDP. A URL leva so a marca `?sso=1` (`lib/idp/marca-sso.ts`),
 * que faz a Wallet tentar o login silencioso em vez de abrir o `/sign-in`.
 *
 * O caminho legado fica: em `IDP_LOGIN=both` quem entrou por senha ainda
 * depende dele. Ele sai junto com o login por senha, em `idp-only`.
 */
import { comMarcaDeSso } from '@/lib/idp/marca-sso';

export function walletHandoffUrl(options: {
  readonly walletUrl?: string;
  readonly comSessaoDoIdp: boolean;
  readonly accessToken?: string;
}): string {
  const base = `${(options.walletUrl ?? '').replace(/\/+$/, '')}/`;

  if (options.comSessaoDoIdp) return comMarcaDeSso(base);
  if (options.accessToken === undefined || options.accessToken.length === 0) return base;

  return `${base}?token=${options.accessToken}`;
}
